import React, { useContext, useEffect, useRef, useState } from 'react';
import { buroContainerCSS } from './BuroContainer.css';
import { Buro1 } from './Buro1/Buro1';
import { Buro2 } from './Buro2/Buro2';
import { scrollToElement } from '../../../Landing/functions';
import { ChooseOptionBuro } from '../ChooseOptionBuro/ChooseOptionBuro';
import { Syntage } from './Syntage/Syntage';
import { LeasingInfo } from './LeasingInfo/LeasinInfo';
import { AuthContext } from '../../../../Context/AuthContext';
import { fetchUser } from '../../../../Components/Functions/functions';
import { url } from '../../../../env';
import { useLocation, useParams } from 'react-router-dom';
import { Authentication } from '../Step4/Authentication';
import { Toast } from 'primereact/toast';
import { Loader } from '../../../../Components';

function BuroContainer({ state, setStep, stepNum }) {
    const { authInfo, setAuthInfo } = useContext(AuthContext)
    const [page, setPage] = useState(1);

    const urlParams = useParams();

    const { secret } = urlParams;
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    //   console.log("params", state)
    let id = params.get("id");
    // const [pageStep3, setPageStep3] = useState(0);
    const [pageStep3, setPageStep3] = useState({
        //selected mode is 0 for none, 1 for tradicional, 2 for syntage
        selectedMethod: authInfo.user.method_slected ? authInfo.user.method_slected : 0,
        //when leasing info is complete and validate number
        completeLeasingInfo: false,
        selectedTypePerson: null,
        uploadDocuments: {
            edosCta: false,
            address: false,
            csf: false,
            // para types = 2 = moral
            actaRppPoderes: false,
            edosFinancieros: false,
            edosCtaAval: false,
            addressAval: false,
            edosFinancieros: false,
            edosCtaAval: false,
            addressAval: false,
        }

    });

    const [userData, setUserData] = useState({
        birthday: null,
        rfc: null,
        address: null,
    });
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        const fecthDataUser = async () => {
            setLoading(true);
            // let dadtat = authInfo.data ? authInfo.data : null;
            // const result = state.fetchUserData ? state.fetchUserData : authInfo.data ? authInfo.data : await fetchUser(url, { secret, id , type: "login"});
            const result = await fetchUser(url, { secret, id, type: "userInfo" });
            // const result = null;
            if (result) {
                setPageStep3({
                    ...pageStep3,
                    selectedMethod: result.method_slected ? result.method_slected : 0,
                    completeLeasingInfo: result.completeSectionLeasingInfo,
                    retomaBot: result.retomaBot === true, // lead del bot con buró hecho (A4)
                    selectedTypePerson: result.selectedTypePerson,
                    infoUser: {
                        name: result.name,
                        email: result.email,
                        phone: result.phone,
                        rfc: result.rfc,
                    },
                    uploadDocuments: {
                        edosCta: result.edosCta,
                        address: result.address,
                        reference: result.reference,
                        // para morales: 
                        actaRppPoderes: result.actaRppPoderes ? result.actaRppPoderes : false,
                        addressAval: result.addressAval ? result.addressAval : false,
                        actaRppPoder: result.actaRppPoder ? result.actaRppPoder : false,
                        edosFinancieros: result.edosFinancierosAval ? result.edosFinancierosAval : false,
                        edosCtaAval: result.edosCtaAval ? result.edosCtaAval : false,
                        addressAval: result.addresAval ? result.addresAval : false,
                        identifications: result.identifications ? result.identifications : false,

                    }
                });
                // comentado por regla de negocio, poder pasar a la siguiente pantalla sin validar Syntage
                // if(result.method_slected != 0 && result.completeSectionLeasingInfo && result.isLoggedSyntage){
                if (result.method_slected != 0 && result.completeSectionLeasingInfo) {

                    // setStep(4)
                    setLoading(false);
                    setPage(4)
                }

            }
            setLoading(false);
        }
        fecthDataUser();
        scrollToElement("HeaderCotizador")
    }, [])

    const toast = useRef(null);
    const show = (severity, detail, summary) => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 3000 });
    };

    return (
        <div css={buroContainerCSS()}>
            {/* escoger opcion */}
            <Toast ref={toast} />
            {loading && <Loader />}
            {
                page === 1 && pageStep3.selectedMethod === 0 &&
                <ChooseOptionBuro setPage={setPage} setPageStep3={setPageStep3} />
                // <Buro1 setPage={setPage} state={state} userData={userData} setUserData={setUserData} />
            }
            {/* leasing form este va en cualquien opcion */}
            {
                page === 1 && !pageStep3.completeLeasingInfo && pageStep3.selectedMethod != 0 && pageStep3.selectedMethod != 3 &&
                <LeasingInfo setPage={setPage} setPageStep3={setPageStep3} setStep={setStep} pageStep3={pageStep3} state={state} />
                // <Buro1 setPage={setPage} state={state} userData={userData} setUserData={setUserData} />
            }

            {
                page === 2 && pageStep3.selectedMethod === 2 && pageStep3.completeLeasingInfo &&
                <Buro2 setPage={setPage} state={state} userData={userData} setUserData={setUserData} />
            }

            {/* Tradicional */}
            {
                page === 1 && pageStep3.selectedMethod === 3 &&
                <Buro1 setPage={setPage} state={state} userData={userData} setUserData={setUserData} setPageStep3={setPageStep3} pageStep3={pageStep3} toast={toast} />
            }
            {/* Syntage */}
            {
                page === 1 && pageStep3.selectedMethod === 2 && pageStep3.completeLeasingInfo &&
                <Syntage setStep={setStep} setPage={setPage} setPageStep3={setPageStep3} state={state} userData={userData} setUserData={setUserData} pageStep3={pageStep3} />
            }
            {/* subir tus edosCuenta, address etc */}
            {
                page === 4 && pageStep3.completeLeasingInfo &&
                <Authentication setStep={setStep} state={state} setPageStep3={setPageStep3} pageStep3={pageStep3}
                    show={show}
                />
            }
        </div>
    );
}

export { BuroContainer };